import React from "react"
import classes from './Template.module.css'

export const ContentLayout = ({ children }) => {
    return (
        <div className={classes.home}>
            {children}
        </div>
    )
}